import type { AxiosRequestConfig } from 'axios';
import axiosInstance from './axiosInstance';

/**
 * Orval이 자동 생성한 API 함수와 프로젝트 공통 통신 설정을 연결한다.
 * orval.config.ts의 mutator 설정에 의해 생성된 API 함수들이 이 함수를 호출한다.
 *
 * 요청 주소·메서드·데이터(config)는 생성된 API 함수가 구성하고,
 * 서버 주소·인증 토큰·요청/응답 변환 등은 axiosInstance가 처리한다.
 * 여기서는 Axios 응답 전체(상태 코드·헤더 등) 중 서버 응답 본문(response.data)만 반환한다.
 * 본문이 { success, data, error }라면 그 객체 전체를 반환하며, 내부 data를 한 번 더 꺼내지 않는다.
 *
 * T는 호출부가 지정한 응답 본문의 타입이며, 실제 서버 응답을 검증하거나 변환하지는 않는다.
 * 이 파일을 분리해 공통 통신 설정과 Orval 전용 반환 형식의 책임을 구분한다.
 */
export const customInstance = <T>(config: AxiosRequestConfig): Promise<T> => {
  return axiosInstance(config).then((response) => response.data as T);
};
